var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center"},[_c('b-icon',{attrs:{"icon":"three-dots","animation":"cylon","variant":"primary","font-scale":"3"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }